// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'
import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';


import {
  Button,
  Icon,
  Checkbox,
  Tooltip,
  Select,
  Input,
  Option,
  Dialog,
  Carousel,
  CarouselItem,
} from 'element-ui';
Vue.use(Icon)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Carousel)
Vue.use(CarouselItem)


import './assets/style/boder.css'
import './assets/style/reset.css'
import less from 'less'
Vue.use(less)
Vue.prototype.$echarts = echarts
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 5000000 // 请求超时时间,
})
Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.prototype.$systemTitle = '医用织物智能一体化管理中心'


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  service,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js